/**
 * Which site this build of the app is (set at build time):
 * - default: served by a Galley server (a school, or a family's own computer), with
 *   /api/session and everything behind it;
 * - `VITE_GALLEY_SITE=hub`: the Curator's Hub's site (Netlify, the repository's netlify.toml).
 *   There is no Galley server behind it: `/` opens the hub, nothing asks /api/session, and the
 *   museum screens reach a family's computer only through a visit (hub/visit.ts).
 *
 * A function rather than a constant so tests can switch it; in a build the comparison is
 * replaced by a literal.
 */
export function isHubSite(): boolean {
  return import.meta.env.VITE_GALLEY_SITE === 'hub'
}
